<template>
  <div>
    <div class="card mt-3" header-bg-variant="white">
      <div class="card-body">
        <PremiumPlanCard
          v-if="subscriptionProduct"
          id="product-card"
          :subscription="subscriptionProduct"
          :isPendingProduct="false"
          :isSameProductDifferentCadence="isSameProductDifferentCadence"
          :apparatusesNeedsAttention="apparatusesNeedsAttention"
          :premiumSubscriptionApparatusMultiplePlans="premiumSubscriptionApparatusMultiplePlans"
          @openCancelPlanMultiplePlansModal="$emit('openCancelPlanMultiplePlansModal')"
          @openManagePlanModal="$emit('openManagePlanModal')"
        />
        <div
          v-if="
            subscription.subscriptionStatus === subscriptionDetailPendingCancel ||
              subscription.subscriptionStatus === subscriptionDetailPendingProductChange
          "
        >
          <hr />
          <PremiumPlanCard
            v-if="subscriptionPendingProduct"
            id="pending-product-card"
            :subscription="subscriptionPendingProduct"
            :isPendingProduct="true"
            :isSameProductDifferentCadence="isSameProductDifferentCadence"
            :apparatusesNeedsAttention="apparatusesNeedsAttention"
            :premiumSubscriptionApparatusMultiplePlans="premiumSubscriptionApparatusMultiplePlans"
            @openCancelPlanMultiplePlansModal="$emit('openCancelPlanMultiplePlansModal')"
            @openManagePlanModal="$emit('openManagePlanModal')"
          />
        </div>
      </div>
    </div>
    <ManagePlanModal :subscription="subscription" />
    <PendingPlanChangeModal
      modalId="pending-plan-change-modal-manage-plan"
      @onYesContinueClick="openModal('manage-plan-modal')"
    />
  </div>
</template>
<script>
import * as Constants from '@/constants'
import ManagePlanModal from './ManagePlanModal.vue'
import PremiumPlanCard from './PremiumPlanCard.vue'
import PendingPlanChangeModal from '../../Common/Subscriptions/PendingPlanChangeModal.vue'

const productIdentifier = {
  SINGLE_FM: 'p-fm-1',
  SINGLE_HSB: 'p-hsb-1',
  SINGLE_HOME: 'p-home-1',
  MULTI_HOME: 'p-home-2'
}

export default {
  components: {
    ManagePlanModal,
    PremiumPlanCard,
    PendingPlanChangeModal
  },
  props: ['subscription', 'apparatusesNeedsAttention', 'premiumSubscriptionApparatusMultiplePlans'],
  data() {
    return {
      subscriptionProduct: null,
      subscriptionPendingProduct: null
    }
  },
  methods: {
    setSubscriptionProduct() {
      this.subscriptionProduct = {
        apparatuses: this.subscription.apparatuses,
        subscriptionCost: this.subscription.subscriptionCost,
        subscriptionDurationInMonths: this.subscription.subscriptionDurationInMonths,
        subscriptionProductId: this.subscription.subscriptionProductId,
        subscriptionProductName: this.subscription.subscriptionProductName,
        subscriptionRenewalDate: this.subscription.subscriptionRenewalDate,
        subscriptionStore: this.subscription.subscriptionStore,
        subscriptionStatus: this.subscription.subscriptionStatus
      }

      if (this.subscription.subscriptionStatus === this.subscriptionDetailPendingProductChange) {
        this.subscriptionPendingProduct = {
          apparatuses: this.subscription.apparatuses,
          subscriptionCost: this.subscription.subscriptionPendingCost,
          subscriptionDurationInMonths: this.subscription.subscriptionPendingDurationInMonths,
          subscriptionProductId: this.subscription.subscriptionPendingProductId,
          subscriptionProductName: this.subscription.subscriptionPendingProductName,
          subscriptionRenewalDate: this.subscription.subscriptionRenewalDate,
          subscriptionStore: this.subscription.subscriptionStore,
          subscriptionStatus: this.subscription.subscriptionStatus,
          subscriptionPendingProductName: this.subscription.subscriptionPendingProductName
        }
      } else if (this.subscription.subscriptionStatus === this.subscriptionDetailPendingCancel) {
        this.subscriptionPendingProduct = this.subscriptionProduct
      }
    }
  },
  watch: {
    subscription(newVal, oldVal) {
      if (newVal) {
        this.setSubscriptionProduct()
      }
    }
  },
  computed: {
    subscriptionDetailPendingCancel() {
      return Constants.SubscriptionDetailPendingCancel
    },
    subscriptionDetailPendingProductChange() {
      return Constants.SubscriptionDetailPendingProductChange
    },
    isSameProductDifferentCadence() {
      var otherCadenceType = null
      if (this.subscription.subscriptionProductId.includes(Constants.SubscriptionDurations.YEARLY)) {
        otherCadenceType = Constants.SubscriptionDurations.MONTHLY
      } else {
        otherCadenceType = Constants.SubscriptionDurations.YEARLY
      }

      if (this.subscription?.subscriptionPendingProductId) {
        if (
          this.subscription.subscriptionProductId.includes(productIdentifier.SINGLE_FM) &&
          this.subscription.subscriptionPendingProductId.includes(productIdentifier.SINGLE_FM) &&
          this.subscription.subscriptionPendingProductId.includes(otherCadenceType)
        ) {
          return true
        } else if (
          this.subscription.subscriptionProductId.includes(productIdentifier.SINGLE_HSB) &&
          this.subscription.subscriptionPendingProductId.includes(productIdentifier.SINGLE_HSB) &&
          this.subscription.subscriptionPendingProductId.includes(otherCadenceType)
        ) {
          return true
        } else if (
          this.subscription.subscriptionProductId.includes(productIdentifier.SINGLE_HOME) &&
          this.subscription.subscriptionPendingProductId.includes(productIdentifier.SINGLE_HOME) &&
          this.subscription.subscriptionPendingProductId.includes(otherCadenceType)
        ) {
          return true
        } else if (
          this.subscription.subscriptionProductId.includes(productIdentifier.MULTI_HOME) &&
          this.subscription.subscriptionPendingProductId.includes(productIdentifier.MULTI_HOME) &&
          this.subscription.subscriptionPendingProductId.includes(otherCadenceType)
        ) {
          return true
        }
      }
      return false
    }
  },
  mounted() {
    if (this.$route?.query?.managePlan) {
      this.$emit('openManagePlanModal')
      this.$router.push({ query: {} })
    }

    this.setSubscriptionProduct()
  }
}
</script>
<style scoped lang="scss">
.current-plan-badge {
  border: 2px solid;
  padding: 5px;
}

.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
</style>
